import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import React from 'react';

import {
  usePartner,
  usePartnerCobranding,
} from 'src/modules/homeownerApp/hooks/usePartner';
import type { AiGeneratedImageFragment } from 'src/shared/graphql/generated';
import { useReactNativeWebView } from 'src/shared/hooks';

import { LensButton } from './LensButton';

interface ImageActionsProps extends BoxProps {
  image: AiGeneratedImageFragment;
}

export const ImageActions = ({ image, ...props }: ImageActionsProps) => {
  const { isLoading: isLoadingPartner } = usePartner();
  const cobranding = usePartnerCobranding();
  const [isWebView] = useReactNativeWebView();

  // Only show Lens button if enabled and does not have an associated org
  // Do not show the lens button in a web-view
  const isLensEnabled = !isWebView && !isLoadingPartner && !cobranding?.orgId;

  return isLensEnabled ? (
    <Box justifyContent="flex-end" padding={500} position="absolute" {...props}>
      <LensButton image={image} />
    </Box>
  ) : null;
};
